export const unlockCurrency = [{
    label: "Gold",
    id: 92,
}, {
    label: "Power",
    id: 93,
}, {
    label: "Money",
    id: 90,
}, {
    label: "Family Chip",
    id: 4,
}, {
    label: "Free",
    id: 99,
}];

export const RARITIES = [{
    label: "Common",
    id: "common",
}, {
    label: "Rare",
    id: "rare",
}, {
    label: "Epic",
    id: "epic",
}, {
    label: "Legendary",
    id: "legendary",
}];

interface Constants {
    listWithCountries: ListWithCountries[];
    objectsNames: ObjectsNamesList[];
    modelNames: ObjectsNamesList[];
    DATEPICKER: string;
    SELECT: string;
}

interface ListWithCountries {
    label: string;
    value: string;
}

interface ObjectsNamesList {
    id: number | string;
    name: string;
}

export const RedisChannel = {
    SERVER: "server",
    USERS: "users",
    SCHEDULER: "scheduler",
    SYNC: "sync",
    TASKS: "tasks",
}

export const RedisEvent = {
    INTERNAL_EVENT: "internal-event",
    UPDATE_EVENTS: "update-events",
    NEW_MESSAGE: "new-message",
    EXECUTE_TASK: "executeTask",
}